"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const ChevronLeft = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M7.777 11.462a.75.75 0 0 0 0 1.076l5.4 5.25a.75.75 0 0 0 1.046-1.076L9.365 12.01l4.858-4.722a.75.75 0 0 0-1.046-1.076l-5.4 5.25z", children: " " })
] });
var ChevronLeft_default = ChevronLeft;
export {
  ChevronLeft_default as default
};
